import { steps } from "./steps";
import { compareVersions } from "../helpers/helpers";
import { darkCharcoal, primaryColor1, whiteColor } from "../helpers/colors";

export const styles = {
  arrowColor: whiteColor,
  backgroundColor: whiteColor,
  overlayColor: "rgba(0, 0, 0, 0.5)",
  primaryColor: primaryColor1,
  textColor: darkCharcoal,
  width: undefined,
  zIndex: 10000,
};

export const getSteps = (apiVersion) => {
  if (!apiVersion) {
    return steps;
  }
  const finalSteps = steps.filter(
    (step) => compareVersions(step.apiVersion, apiVersion) > 0
  );
  return finalSteps;
};

export const getMaxVersion = (versionArray) => {
  return versionArray
    .map((v) => {
      if (v.split(".").length !== 3) {
        return [0, 0, 0];
      }
      return v.split(".").map((vs) => {
        return parseInt(vs, 10);
      });
    })
    .sort((a, b) => {
      return a[0] * 100 + a[1] * 10 + a[2] > b[0] * 100 + b[1] * 10 + b[2];
    })
    .pop()
    .join(".");
};
